<template>
  <div></div>
</template>

<script>
import { filterUserListSubscription } from "@/modules/user/utilities/userListHelpers";
import { SUBSCRIBE_USER_LIST_BY_TEAM_ID } from "@/modules/user/graphql/FetchUserListByTeamId";

export default {
  name: "FetchUserList",
  data() {
    return {
      userList: []
    };
  },
  apollo: {
    $subscribe: {
      userList: {
        query: SUBSCRIBE_USER_LIST_BY_TEAM_ID,
        variables() {
          return {
            team_id: this.$store.state.AppActiveUser.team.id
          };
        },
        result(subscription) {
          this.userList = filterUserListSubscription(subscription);
          this.$store.dispatch("updateUserList", this.userList);
        }
      }
    }
  }
};
</script>

<style></style>
